





























































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { formatTimeStr, generateUUID } from '@/utils/other';
import { generateOptions } from '@/utils/todo';
import moment, {Moment} from 'moment';
import { moduleListInstance } from '@/model/ModuleListClass';
import { todoListInstance } from '@/model/TodoListClass';
import ConfirmContent from './confirmContent.vue';
import CopyTodoModal from './copyTodoModal.vue';
import { batchUpdateTodo } from '@/api/todo';
import SelectMemberModal from './selectMemberModal.vue';
import SelectTeamModal from './selectTeamModal.vue';
import { generateLeaderTeams } from '@/utils/team';
import { AccountModule } from '@/store/modules/account';
import { BATCH_CREATED_TODO_EVENT, pubsub } from '@/utils/pubsub';

type IModuleInfo = IModule.IResponse.IModuleInfo;
type ITodoInfo = ITodo.IResponse.ITodoInfo;
type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;

const titleColumn = {
  slots: { title: 'todoTitle' },
  dataIndex: 'title',
  ellipsis: true,
  width: '16%',
};
const dueColumn = {
  slots: { title: 'dueTitle' },
  dataIndex: 'due',
  scopedSlots: { customRender: 'due' },
  width: '11%',
  align: 'center',
  sorter: (a: ITodoInfo, b: ITodoInfo) => {
    return new Date(a.due).valueOf() - new Date(b.due).valueOf();
  },
};
const manDayColumn = {
  slots: { title: 'manDayTitle' },
  dataIndex: 'manDay',
  width: '10%',
  align: 'center',
  sorter: (a: ITodoInfo, b: ITodoInfo) => a.manDay - b.manDay,
};
const bonusColumn = {
  slots: { title: 'bonusTitle' },
  dataIndex: 'isBonus',
  scopedSlots: { customRender: 'bonus' },
  width: '10%',
  align: 'center',
  filters: [{text: 'Yes', value: 'Yes'}, {text: 'No', value: 'No'}],
  onFilter: (value: string, record: ITodoInfo) => (value === 'Yes') === record.isBonus,
};
const copyColumn = {
  key: 'copy',
  slots: { title: 'copyTitle' },
  scopedSlots: { customRender: 'copy' },
  width: '5%',
};
const copyReg = /_copy\d+/;
@Component({
  components: {
    CopyTodoModal,
    SelectMemberModal,
    SelectTeamModal,
  },
  filters: {
    formatTimeStr,
  },
})
export default class ModuleTodo extends Vue {
  @Prop({required: true}) private module!: IModuleInfo;
  @Ref() private readonly copyTodoModalRef!: CopyTodoModal;
  @Ref() private readonly selectMemberModalRef!: SelectMemberModal;
  @Ref() private readonly selectTeamModalRef!: SelectTeamModal;
  private isShowRowSelection = false;
  private rowSelectionType = '';
  private submitLoading = false;
  private selectedTodos: ITodoInfo[] = [];
  private totalManDay = 0;
  private selectCopyTodoInfo: ITodoInfo | null = null;
  private memberOptions: IUserDetailInfo[] = [];
  get isSettled() {
    return this.module.status === 'Completed';
  }
  get canSettle() {
    return this.module.status === 'Processing';
  }
  get canCreateTodo() {
    return this.module.status === 'Processing' &&
    (this.totalManDay <= this.module.manDay) &&
    (moment().valueOf() < moment(this.module.due).endOf('d').valueOf());
  }
  get todos() {
    this.calcTotalManDay(this.module.todos);
    return this.module.todos;
  }
  get rowSelection() {
    if (this.rowSelectionType === 'Settlement') {
      return {
        onChange: (selectedRowKeys: string, selectedRows: ITodo.IResponse.ITodoInfo[]) => {
          this.selectedTodos = selectedRows.map((row) => {
            return row;
          });
        },
        getCheckboxProps: (record: ITodo.IResponse.ITodoInfo) => ({
          props: {
            disabled: record.status !== 'Reviewed', // Column configuration not to be checked
          },
        }),
        columnWidth: '5%',
      };
    } else if (this.rowSelectionType === 'UpdateOwner' || this.rowSelectionType === 'UpdateTeams') {
      return {
         onChange: (selectedRowKeys: string, selectedRows: ITodo.IResponse.ITodoInfo[]) => {
          this.selectedTodos = selectedRows.map((row) => {
            return row;
          });
        },
        getCheckboxProps: (record: ITodo.IResponse.ITodoInfo) => ({
          props: {
            disabled: record.status !== 'Processing' || !record.due, // Column configuration not to be checked
          },
        }),
        columnWidth: '5%',
      };
    } else {
      return null;
    }
  }
  get columns() {
    const { typeOption, ownerOption, statusOption, settlementUnitOption } = generateOptions(this.module.todos);
    const typeColumn = {
      slots: { title: 'typeTitle' },
      dataIndex: 'typeName',
      scopedSlots: { customRender: 'typeId' },
      width: '12%',
      ellipsis: true,
      filters: typeOption,
      onFilter: (value: string, record: ITodoInfo) => {
        return record.typeId === value;
      },
    };
    const ownerColumn = {
      slots: { title: 'ownerTitle' },
      dataIndex: 'ownerName',
      scopedSlots: { customRender: 'owner' },
      width: '13%',
      filters: ownerOption,
      onFilter: (value: string, record: ITodoInfo) => {
        if (value === 'Null') {
          return record.owner === null;
        }
        return record.owner === value;
      },
    };
    const statusColumn = {
      slots: { title: 'statusTitle' },
      dataIndex: 'status',
      width: '10%',
      align: 'center',
      filters: statusOption,
      onFilter: (value: string, record: ITodoInfo) => record.status === value,
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationName',
      slots: { title: 'settlementUnitTitle' },
      width: '8%',
      align: 'center',
      filters: settlementUnitOption,
      onFilter: (value: string, record: ITodoInfo) => record.settlementConfigurationId === value,
    };
    const patternTypeColumn = {
      dataIndex: 'patternType',
      slots: { title: 'patternTypeTitle' },
      scopedSlots: { customRender: 'patternType' },
      width: '4%',
      align: 'center',
    };
    const column = [
      copyColumn,
      titleColumn,
      typeColumn,
      ownerColumn,
      patternTypeColumn,
      dueColumn,
      statusColumn,
      manDayColumn,
      settlementUnitColumn,
      bonusColumn,
    ];
    if (this.isShowRowSelection) {
      column.shift();
    }
    return column;
  }
  private created() {
    generateLeaderTeams(AccountModule.userDetailInfo!.id).then((res) => {
      this.memberOptions = res;
    }).catch((err) => err);
  }
  private handleSettlement() {
    this.rowSelectionType = 'Settlement';
    this.isShowRowSelection = true;
    this.selectedTodos = [];
  }
  private showConfirm() {
    let todoCount = 0;
    let todoManday = 0;
    const paymentManDay = this.module.manDay;
    if (this.selectedTodos.length !== 0) {
      todoCount = this.selectedTodos.length;
      todoManday = this.selectedTodos.map((todo) => todo.manDay).reduce((total, manDay) => total += manDay);
    }
    todoManday = Number(todoManday.toFixed(2));
    if (todoManday > paymentManDay ) {
      const tips = this.$t('module.overQuotation').toString();
      this.$message.warning(tips);
      return;
    }
    const title = this.$t('module.settlement').toString();
    const content = this.$createElement(
      ConfirmContent,
      {
        props: {
          language: this.$i18n.locale,
          paymentManDay: paymentManDay.toFixed(2),
          todoCount,
          todoManday: todoManday.toFixed(2),
        },
      },
    );
    this.$confirm({
      title,
      content,
      onOk: () => {
        this.submitSettlement();
      },
      width: 500,
    });
  }
  private submitSettlement() {
    const params = this.selectedTodos.map((todo) => {
      return todo.id;
    });
    this.submitLoading = true;
    moduleListInstance.requestModuleSettles(this.module, params).then((res) => {
      this.$message.success(res);
      this.submitLoading = false;
      this.rowSelectionType = '';
      this.isShowRowSelection = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.submitLoading = false;
    });
  }
  private handleCreate() {
    todoListInstance.createTodo({
      moduleId: this.module.id,
      moduleTitle: this.module.title,
      moduleDue: this.module.due,
      projectName: this.module.projectName,
      projectId: this.module.projectId,
    });
    this.$router.push({name: 'CreateTodo'});
  }
  private calcTotalManDay(todos: ITodoInfo[]) {
    const totalManDay = todos.reduce((total, todo) => {
      if (todo.status !== 'Closed') {
        return total + todo.manDay;
      }
      return total;
    }, 0);
    this.totalManDay = parseFloat(totalManDay.toFixed(2));
  }
  private handleTableChange(pagination: any, filters: any, sorter: any, data: {currentDataSource: ITodoInfo[]}) {
    this.calcTotalManDay(data.currentDataSource);
  }
  private getCopyCount() {
    let copyArr: string[] = [];
    let numberArr: number[] = [];
    this.todos.forEach((item) => {
      const res = item.title.match(copyReg);
      if (res) {
        copyArr = copyArr.concat(res);
      }
    });
    if (copyArr.length === 0) {
      return 0;
    }
    numberArr = copyArr.map((item) => Number(item.match(/\d+/)));
    numberArr.sort((a, b) => b - a);
    return numberArr[0];
  }
  private batchCopyTodo(data: {todo: ITodoInfo, dates: Moment[]}) {
    if (!data.todo || data.dates.length === 0) {
      return;
    }
    const {
      moduleId, typeId, typeName, manDay, title, description, owner, due,
      settlementConfigurationId, patternType, teamIds, isAgree,
    } = data.todo;
    const copyCount = this.getCopyCount();
    const newTodos: ITodo.IRequest.IBatchCreateTodoParams[] = data.dates.map((item: Moment, index) => {
      return {
        id: generateUUID(),
        moduleId,
        typeId,
        typeName,
        isBonus: false,
        manDay,
        title: title.replace(copyReg, '') + '_copy' + (copyCount + index + 1),
        description,
        owner: isAgree ? owner : null,
        due: item.format('YYYY-MM-DD'),
        settlementConfigurationId,
        comment: '',
        patternType: isAgree ? 0 : patternType,
        teamIds: isAgree ? [] : teamIds,
      };
    });
    this.createTodo(newTodos);
  }
  private createTodo(todos: ITodo.IRequest.IBatchCreateTodoParams[]) {
    todoListInstance.requestBatchCreateTodo(todos).catch((err) => {
      this.$message.warning(err);
    });
  }
  private showCopyModal(todo: ITodoInfo) {
    this.selectCopyTodoInfo = todo;
    this.copyTodoModalRef.showModal();
  }
  private dueDisabledDate(current: Moment) {
    let endDate = moment().endOf('year');
    const startDate = moment().startOf('day');
    if (this.module.due) {
      endDate = moment(this.module.due).endOf('day');
    }
    return current && (current < startDate || current > endDate);
  }
  private changeTodoDue(date: Moment, todo: ITodoInfo) {
    if (!date) {
      return;
    }
    batchUpdateTodo([{
      owner: todo.owner,
      todoId: todo.id,
      patternType: todo.patternType,
      due: date.format('YYYY-MM-DD'),
      teamIds: todo.teamIds,
    }]).then((res) => {
      pubsub.publish(BATCH_CREATED_TODO_EVENT, this.module.id);
    }).catch((err) => {
      this.$message.warning(err.message);
    });
  }
  private changeTodoMember(memberId: string) {
    if (!memberId) {
      return;
    }
    this.submitLoading = true;
    batchUpdateTodo(
      this.selectedTodos.map((item) => (
        {
          owner: memberId,
          todoId: item.id,
          patternType: 0,
          due: item.due,
          teamIds: [],
        }
      )),
    ).then((res) => {
      this.$message.success(res.message);
      this.submitLoading = false;
      this.rowSelectionType = '';
      this.isShowRowSelection = false;
      pubsub.publish(BATCH_CREATED_TODO_EVENT, this.module.id);
    }).catch((err) => {
      this.$message.warning(err.message);
      this.submitLoading = false;
    });
  }
  private changeTodoTeams(teamIds: string[]) {
    if (teamIds.length === 0) {
      return;
    }
    this.submitLoading = true;
    batchUpdateTodo(
      this.selectedTodos.map((item) => (
        {
          owner: null,
          todoId: item.id,
          patternType: 1,
          due: item.due,
          teamIds,
        }
      )),
    ).then((res) => {
      this.$message.success(res.message);
      this.submitLoading = false;
      this.rowSelectionType = '';
      this.isShowRowSelection = false;
      pubsub.publish(BATCH_CREATED_TODO_EVENT, this.module.id);
    }).catch((err) => {
      this.$message.warning(err.message);
      this.submitLoading = false;
    });
  }
  private handleUpdateGrab() {
    this.rowSelectionType = 'UpdateTeams';
    this.isShowRowSelection = true;
    this.selectedTodos = [];
  }
  private handleUpdateOwner() {
    this.rowSelectionType = 'UpdateOwner';
    this.isShowRowSelection = true;
    this.selectedTodos = [];
  }
  private handleRowSelectionCancel() {
    this.isShowRowSelection = false;
    this.rowSelectionType = '';
  }
  private handleRowSelectionSubmit() {
    if (this.rowSelectionType === 'Settlement') {
      this.showConfirm();
    } else if (this.rowSelectionType === 'UpdateOwner') {
      if (this.selectedTodos.length > 0) {
        this.selectMemberModalRef.showModal();
      } else {
        this.$message.warning('未选择todo');
      }
    } else if (this.rowSelectionType === 'UpdateTeams') {
      if (this.selectedTodos.length > 0) {
        this.selectTeamModalRef.showModal();
      } else {
        this.$message.warning('未选择todo');
      }
    }
  }
}
